import { Button } from '@saleshandy/design-system';
import React, { ReactNode } from 'react';

export const getNavItemDemoInfo = (
  key: string,
  handleShouldShowSidebarInfo: VoidFunction,
): ReactNode => {
  if (key === 'sequence') {
    return (
      <div className="nav-item-demo-info sequence">
        <div className="nav-item-demo-info-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="76"
            height="24"
            viewBox="0 0 76 24"
            fill="none"
          >
            <path
              d="M75.9613 0.482525L70.2518 1.3399L73.8491 5.85578L75.9613 0.482525ZM1 22.0418L0.931579 22.5371C20.105 25.1858 33.6068 24.0115 44.5592 20.3875C55.5078 16.7649 63.8651 10.7075 72.751 3.67905L72.4408 3.28689L72.1306 2.89473C63.2579 9.91266 55.0165 15.8742 44.2451 19.4382C33.4777 23.0009 20.1383 24.1809 1.06842 21.5465L1 22.0418Z"
              fill="white"
            />
          </svg>
          <p>Send outreach emails on autopilot</p>
        </div>
      </div>
    );
  }

  if (key === 'tasks') {
    return (
      <div className="nav-item-demo-info sequence">
        <div className="nav-item-demo-info-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="76"
            height="24"
            viewBox="0 0 76 24"
            fill="none"
          >
            <path
              d="M75.9613 0.482525L70.2518 1.3399L73.8491 5.85578L75.9613 0.482525ZM1 22.0418L0.931579 22.5371C20.105 25.1858 33.6068 24.0115 44.5592 20.3875C55.5078 16.7649 63.8651 10.7075 72.751 3.67905L72.4408 3.28689L72.1306 2.89473C63.2579 9.91266 55.0165 15.8742 44.2451 19.4382C33.4777 23.0009 20.1383 24.1809 1.06842 21.5465L1 22.0418Z"
              fill="white"
            />
          </svg>
          <p>Manage your multi-channel tasks</p>
        </div>
      </div>
    );
  }

  if (key === 'unifiedInbox') {
    return (
      <div className="nav-item-demo-info unifiedInbox">
        <div className="nav-item-demo-info-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="79"
            height="16"
            viewBox="0 0 79 16"
            fill="none"
          >
            <path
              d="M78.3433 0.345121L75.3763 5.29788L72.5706 0.251945L78.3433 0.345121ZM1.00001 10.4451L1.11078 9.95756C16.1547 13.3753 27.8515 14.9478 39.0628 13.9036C50.2662 12.8601 61.0226 9.1997 74.173 2.09188L74.4108 2.53174L74.6485 2.9716C61.4197 10.1218 50.532 13.8397 39.1555 14.8993C27.7867 15.9581 15.9678 14.3583 0.889245 10.9327L1.00001 10.4451Z"
              fill="white"
            />
          </svg>
          <p>See replies of your outreach</p>
        </div>
      </div>
    );
  }

  if (key === 'agency-client') {
    return (
      <div className="nav-item-demo-info agencyClient">
        <div className="nav-item-demo-info-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="79"
            height="18"
            viewBox="0 0 79 18"
            fill="none"
          >
            <path
              d="M78.5514 6.17006L73.1218 8.13295L74.1367 2.44935L78.5514 6.17006ZM0.879002 17.5057L0.556885 17.1232C15.0749 4.89428 27.901 0.744458 39.9255 0.212342C51.909 -0.317956 63.0902 2.75366 74.2165 4.88814L74.1223 5.37919L74.0281 5.87024C62.7998 3.71619 51.7993 0.687878 39.9697 1.21136C28.1813 1.73303 15.563 5.7907 1.20112 17.8881L0.879002 17.5057Z"
              fill="white"
            />
          </svg>
          <p>Organize and manage your clients better</p>
        </div>
      </div>
    );
  }

  if (key === 'leads') {
    return (
      <div className="nav-item-demo-info leads">
        <div className="nav-item-demo-info-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="78"
            height="19"
            viewBox="0 0 78 19"
            fill="none"
          >
            <path
              d="M77.9394 0.364612L72.172 0.631218L75.2866 5.49258L77.9394 0.364612ZM1 13.184L0.86911 13.6665C19.6631 18.7642 33.2301 19.2336 44.5289 16.8712C55.8232 14.5096 64.8036 9.32686 74.4164 3.21551L74.1481 2.79356L73.8799 2.37161C64.2809 8.47417 55.4298 13.5703 44.3242 15.8923C33.2231 18.2135 19.8219 17.7711 1.13089 12.7014L1 13.184Z"
              fill="white"
            />
          </svg>
          <p>Find leads to start your outreach</p>
        </div>
      </div>
    );
  }

  if (key === 'prospects') {
    return (
      <div className="nav-item-demo-info prospects">
        <div className="nav-item-demo-info-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="79"
            height="12"
            viewBox="0 0 79 12"
            fill="none"
          >
            <path
              d="M78.9625 11.3357L75.5221 6.69925L73.227 11.997L78.9625 11.3357ZM1.00046 8.90237L1.15871 9.37666C15.7929 4.49386 27.278 1.777 38.5375 1.71191C49.7893 1.64686 60.8539 4.2301 74.6404 10.0082L74.8337 9.54703L75.027 9.0859C61.1583 3.2734 49.9573 0.645875 38.5317 0.711924C27.114 0.777928 15.5101 3.53401 0.842209 8.42807L1.00046 8.90237Z"
              fill="white"
            />
          </svg>
          <p>Track and manage your target</p>
        </div>
      </div>
    );
  }

  if (key === 'email-accounts') {
    return (
      <div className="nav-item-demo-info emailAccounts">
        <div className="nav-item-demo-info-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="79"
            height="15"
            viewBox="0 0 79 15"
            fill="none"
          >
            <path
              d="M78.7731 0.37868L73.0037 0.160293L75.6993 5.26591L78.7731 0.37868ZM1.0293 6.69528L0.858367 7.16516C19.1582 13.8222 32.6379 15.4287 44.0951 14.0229C55.5478 12.6176 64.9315 8.20683 75.0233 2.92383L74.7914 2.48086L74.5595 2.03789C64.4823 7.31327 55.2346 11.6485 43.9733 13.0303C32.7166 14.4115 19.3998 12.846 1.20023 6.22541L1.0293 6.69528Z"
              fill="white"
            />
          </svg>
          <p>Set up your email to start sending</p>
        </div>
      </div>
    );
  }

  if (key === 'inbox-radar') {
    return (
      <div className="nav-item-demo-info inboxRadar">
        <div className="nav-item-demo-info-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="79"
            height="15"
            viewBox="0 0 79 15"
            fill="none"
          >
            <path
              d="M78.7731 0.37868L73.0037 0.160293L75.6993 5.26591L78.7731 0.37868ZM1.0293 6.69528L0.858367 7.16516C19.1582 13.8222 32.6379 15.4287 44.0951 14.0229C55.5478 12.6176 64.9315 8.20683 75.0233 2.92383L74.7914 2.48086L74.5595 2.03789C64.4823 7.31327 55.2346 11.6485 43.9733 13.0303C32.7166 14.4115 19.3998 12.846 1.20023 6.22541L1.0293 6.69528Z"
              fill="white"
            />
          </svg>
          <p>Run tests to check email placement.</p>
        </div>
      </div>
    );
  }

  if (key === 'reports') {
    return (
      <div className="nav-item-demo-info reports">
        <div className="nav-item-demo-info-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="79"
            height="12"
            viewBox="0 0 79 12"
            fill="none"
          >
            <path
              d="M78.6842 11.3357L75.2437 6.69925L72.9487 11.997L78.6842 11.3357ZM0.722141 8.90237L0.880394 9.37666C15.5145 4.49386 26.9997 1.777 38.2592 1.71191C49.5109 1.64686 60.5755 4.2301 74.3621 10.0082L74.5554 9.54703L74.7486 9.0859C60.8799 3.2734 49.679 0.645875 38.2534 0.711924C26.8357 0.777928 15.2318 3.53401 0.563889 8.42807L0.722141 8.90237Z"
              fill="white"
            />
          </svg>
          <p>Track how your emails and campaigns perform</p>
          <Button onClick={handleShouldShowSidebarInfo}>Got it</Button>
        </div>
      </div>
    );
  }

  return <></>;
};
